import { createSlot } from '@ayocore/platform/client/extensions/createSlot';
import type { RpcRepositoryClient } from '@ayocore/platform/server/rpc/types';
// Тип строки живёт в самом списке. Импорт только типовой — на рантайме он
// стирается, поэтому кольца LeadsList → LeadListExtensions не возникает.
import type { LeadExtended } from './LeadsList';

/**
 * Что список отдаёт действию в момент нажатия.
 *
 * Без этого действие не знает про фильтры таблицы и может работать только со
 * всей базой — именно так выгрузка «Входящие заявки» игнорировала фильтр.
 */
export interface LeadListActionContext {
  /**
   * Репозиторий заявок с уже применёнными фильтрами таблицы: вызов
   * терминального метода уйдёт одной RPC-цепочкой, фильтрация останется
   * на сервере. `null`, пока таблица не смонтирована.
   */
  getRepository: () => RpcRepositoryClient<LeadExtended> | null;
}

/** Описание дополнительного действия для списка лидов */
export interface LeadListAction {
  title: string;
  handler: (ctx: LeadListActionContext) => void | Promise<void>;
  icon?: React.ReactNode;
}

/**
 * Точки расширения LeadsList.
 *
 * Позволяют клиентским модулям добавлять действия
 * в панель инструментов списка лидов.
 *
 * @example
 * LeadListExtensions.actions.register(() => ({
 *   title: 'Выгрузить отчёт',
 *   handler: async ({ getRepository }) => { ... },
 *   icon: <IconFileSpreadsheet size={14} />,
 * }));
 */
export const LeadListExtensions = {
  /** Дополнительные действия (кнопки в панели инструментов) */
  actions: createSlot<void, LeadListAction | null>(),
};
